// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatFilledSvg from "@ant-design/icons-svg/es/asn/WechatFilled";
import AntdIcon from '../components/AntdIcon';

var WechatFilled = function WechatFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WechatFilledSvg
  }));
};

WechatFilled.displayName = 'WechatFilled';
export default React.forwardRef(WechatFilled);